<template>
  <div class="get-the-look__product q-row">
    <div class="q-col-4">
      <img class="get-the-look__image" v-lazy="productImage">
    </div>
    <div class="qet-the-look__product-info-box q-col-8">
      <div class="get-the-look__product-info q-col-12">
        <h6 v-if="brand" class="get-the-look__brand ">{{ brand }}</h6>
        <h2 class="get-the-look__title ">{{ product.title }}</h2>
      </div>
      <div class="get-the-look__product-prices-box q-col-12">
        <p v-if="discount" class="get-the-look__discount">
          <span class="get-the-look__discount-box">-{{ discount }}%</span>
        </p>
        <p class="get-the-look__prices">
          <span class="get-the-look__price-text">{{priceText}}</span>
          <del v-if="oldPrice && oldPrice !== actualPrice" class="get-the-look__price-old">{{oldPrice}}</del>
          <strong class="get-the-look__price" :class="{'--promotion': discount }">{{actualPrice}}</strong>
        </p>

        <p v-if="omnibusPrice" class="get-the-look__omnibus">
          <span class="get-the-look__omnibus-text">{{ omnibusText }}</span>
          <span class="get-the-look__omnibus-price">{{ omnibusPrice }}</span>
        </p>
      </div>
    </div>

    <a :href="actualLink"
       @click="handleClick"
       class="q-stretched-link get-the-look__link"
       :target="useAsSeparate ? '_self' : '_blank'"></a>

  </div>


</template>
<script setup lang="ts">
import {generateStaticImage, formatPrice, getDiscount, parsePrice} from '@/core/utils'
import {defineProps, ref, PropType} from 'vue'

const props = defineProps({
  product: [],
  useAsSeparate: {
    type: Boolean as PropType<boolean>,
    default: true
  }
});

const productImage = ref(generateStaticImage(props.product.image_link, 301, null))
// const productImage = ref(props.product.image_link)
const clickLink = ref(props.product.link_click)
const formattedPrice = ref(formatPrice(props.product.price))
const firstVariant = ref(props.product.variants[0])
const brand = ref(firstVariant.value.brand)
const salePrice = ref(formatPrice(firstVariant.value.sale_price))

const actualPrice = salePrice.value ? salePrice.value : formattedPrice.value
const oldPrice = salePrice.value ? formattedPrice.value : salePrice.value

const priceNumber = parsePrice(actualPrice)
const oldPriceNumber = parsePrice(oldPrice)
const discount = ref(getDiscount(priceNumber, oldPriceNumber))

const omnibusPrice = ref(formatPrice(firstVariant.value.omnibus_price))
const omnibusText = ref('Najniższa cena produktu w okresie 30 dni przed wprowadzeniem obniżki: ')
const priceText = ref('Cena regularna: ')

const actualLink = ref(firstVariant.value.link)

const handleClick = () => {
  actualLink.value = clickLink.value
};


</script>
<style scoped>
.get-the-look__link {
  cursor: pointer;
}

.get-the-look__product {
  position: relative!important;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.get-the-look__discount-box {
  display: inline-block;
  background: red;
  color: #fff;
  font-size: 1.2rem;
  padding: 1px 8px;
  position: relative;
  margin-bottom: 10px;
}

.get-the-look__total-price {
  white-space: nowrap;
  font-family: 'Montserrat', Arial, sans-serif;

}

.get-the-look__total-price.--promotion {
  color: red;

}

.get-the-look__omnibus {
  font-size: 0.75rem;
  margin: 0;
  width: 100%;
  font-family: 'Gotham', Arial, sans-serif;
  font-weight: 400;
  line-height: 1.3;
  color: #333;
}

.get-the-look__title {
  font-size: 1rem;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'Gotham', Arial, sans-serif;
  font-weight: 500;
}

.get-the-look__product img {
  border-radius: 5px;
  max-width: 100%;
}

/*.get-the-look__product-info {*/
/*  margin-left: 15px;*/
/*}*/

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>